/*
Author : Arman Ali
Module: Document panel
github: https://github.com/Arman-Arzoo
*/

import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstanceV2 } from '../../Apis/AxiosV2';
import fileDownload from 'js-file-download';
import { DEPARTMENT_SERVICE, DOCUMENT_SERVICE, IMAGE_SERVICE } from '../EndPoints';


// delete document by id
export const DeleteDocumentById = createAsyncThunk(
    'documentPanel/deleteDocumentById',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .delete(IMAGE_SERVICE.deleteDocumentById(params?.id, params?.option))
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);


// get all departments
export const GetAllDepartments = createAsyncThunk(
    'documentPanel/getAllDepartments',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(DEPARTMENT_SERVICE.getDepartments)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// create emplyee doc
export const CreateEmployeeDoc = createAsyncThunk(
    'documentPanel/createEmployeeDoc',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(DOCUMENT_SERVICE.createEmployeeDoc, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

// update employee doc
export const UpdateEmployeeDoc = createAsyncThunk(
    'documentPanel/updateEmployeeDoc',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(DOCUMENT_SERVICE.updateEmployeeDoc, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// get employee doc
export const GetEmployeeDocById = createAsyncThunk(
    'documentPanel/getEmployeeDocById',
    async (param, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`${DOCUMENT_SERVICE.getEmployeeDocById}${param}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);


// create contractor doc
export const CreateContractorDoc = createAsyncThunk(
    'documentPanel/createContractorDoc',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(DOCUMENT_SERVICE.createContractorDoc, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// update contractor doc
export const UpdateContractorDoc = createAsyncThunk(
    'documentPanel/updateContractorDoc',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(DOCUMENT_SERVICE.updateContractorDoc, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// get contractor doc
export const GetContractorDocById = createAsyncThunk(
    'documentPanel/getContractorDocById',
    async (param, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`${DOCUMENT_SERVICE.getContractorDocById}${param}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);